'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../box'

/* -----------------------------------------------------------------------------
 * Tabs
 * -------------------------------------------------------------------------- */

export type TabsProps = BoxProps & {
  children: React.ReactNode
}

function Tabs({ children, ...rest }: TabsProps) {
  return (
    <Box flexDirection='row' {...rest}>
      {children}
    </Box>
  )
}

export default Tabs
